import { PageSpinner } from '@branch-messenger/willow-ui'

export const PageLoader = () => <PageSpinner open={true} />
